// What only the server knows about this project.
//
// Some capabilities are decided by the FUNCTIONS environment, which the admin
// browser cannot read: whether a season ticket verification can complete comes
// down to TM_API_KEY being set there. The admin used to guess from
// REACT_APP_HAS_TICKETMASTER, a build-time flag that answers a different
// question — "does this club sell tickets through Ticketmaster in-app", which
// gates the ticket entries an operator can add to the side menu and home
// buttons. A club can have one and not the other.
//
// Cached per page load because two screens ask (Feature Access, Offers) and the
// answer cannot change without a functions deploy. Failures are cached too, as
// null, so a broken environment does not retry on every render.

let pending = null;

let apiUrl = `https://us-central1-${process.env.REACT_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net/api/`;
if (process.env.NODE_ENV === 'development') {
    apiUrl = `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJECT_ID}/us-central1/api/`;
}

/**
 * @param userData the signed-in admin, for its ID token
 * @returns the capability object, or null when it could not be read — which
 *          every caller must treat as "capable", so a slow or failed request
 *          never takes a switch off the screen.
 */
export function loadServerCapabilities(userData) {
    if (pending) return pending;
    pending = (async () => {
        try {
            const token = userData ? await userData.getIdToken() : null;
            if (!token) return null;
            const response = await fetch(apiUrl + 'serverCapabilities', {
                headers: { Authorization: 'Bearer ' + token }
            });
            if (!response.ok) return null;
            return await response.json();
        } catch (e) {
            console.log('Could not read server capabilities:', e);
            return null;
        }
    })();
    return pending;
}

// Tests, and anywhere a fresh read is genuinely wanted.
export function invalidateServerCapabilities() {
    pending = null;
}
